<template>
  <NavigationLayout
    :navigation-title="title"
    :navigation-bar-style="{
      'flex-direction': 'row',
      'justify-content': 'flex-start',
      'padding-left': '16px',
      'z-index': '2',
      'top': 'var(--safe-area-inset-top, 0px)',
    }"
    :navigation-content-style="{
      'padding-top': 'var(--safe-area-inset-top, 0px)',
    }"
    v-if="!isLoading"
  >
    <div v-if="!showNotFound()" slot="contents">
      <div v-if="!isWebView()" class="account_info">
        <div class="info">
          <div class="username">
            {{ user != null ? user.username : '' }}
          </div>
          <div class="coin_info">
            <coin-amount :amount="coin" />
          </div>
        </div>
        <div class="icon">
          <icon-image :icon-url="user != null ? user.iconUrl : ''" size="28" />
        </div>
      </div>
      <div v-else class="account_info">
        <!-- dummy block -->
      </div>
      <div class="charge_grade_prize_detail_container">
        <div
          class="threshould_setting_header"
          :style="headerBackGroundImageStyles"
        >
          <div class="threshould_setting_icon">
            <img :src="thresholdSetting.statusIconUrl" width="64" />
          </div>
          <div class="threshould_setting_text">
            {{ thresholdSetting.name }}
          </div>
          <div class="threshould_setting_detail_text">
            {{
              $t('charge_grade_low_amount_range', {
                lowAmountRange: lowAmountRange,
              })
            }}
          </div>
        </div>
        <div class="prize_contents_text">
          {{ $t('grade_benefit_details__subtitle__content') }}
        </div>
        <div class="prize_list_container">
          <div
            v-for="prizeSetting in prizeSettings"
            :key="prizeSetting.id"
            class="prize_item"
          >
            <div class="item_icon">
              <img :src="prizeSetting.prizeIconUrl" width="65" />
            </div>
            <div class="item_name">{{ prizeSetting.name }}</div>
            <div class="item_description">
              <!-- 改行しないように注意 -->
              <p>{{ prizeSetting.prizeDescriptionText }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <not-found
      v-show="showNotFound()"
      class="charge_grade_prize_detail_notfound"
      slot="contents"
    />
  </NavigationLayout>
</template>

<script lang="ts">
import { Component, Mixins } from 'vue-property-decorator'
import { LanguageQueryHandler } from '@/mixins/LanguageQuery'
import NavigationLayout from '@/components/NavigationLayout.vue'
import CoinAmount from '@/components/Mypage/CoinAmount.vue'
import IconImage from '@/components/IconImage.vue'
import { api } from '@/api/appGatewayServerApi'
import { checkInMaintenance } from '@/utils/maintenance'
import { handleUnauthorized } from '@/utils/handle_error'
import { ApiError } from '@/api/error'
import NotFound from '@/components/Error/NotFound.vue'
import * as models from '@/models'
import { getTokenFromCookie } from '@/utils/token'
import Formatter from '@/utils/Formatter'

@Component({
  components: {
    NotFound,
    NavigationLayout,
    CoinAmount,
    IconImage,
  },
})
export default class ChargeGradePrizeDetail extends Mixins(
  LanguageQueryHandler
) {
  thresholdSettingId: number = 0
  thresholdSetting: models.ChargeGradeThresholdSetting =
    {} as models.ChargeGradeThresholdSetting
  prizeSettings: models.ChargeGradePrizeSettings = []
  user: models.UserInfo | null = null
  coin: number = 0
  lowAmountRange: string = '0'

  isNotFound: boolean = false
  isLoading: boolean = false

  checkVersion = false

  created() {
    const thresholdSettingId = this.$route.params.thresholdSettingId as string
    this.checkVersion = this.$route?.meta?.checkVersion ?? false
    if (thresholdSettingId) {
      this.thresholdSettingId = parseInt(thresholdSettingId)
    }
    this.fetchPrizeDetail()
  }

  async fetchPrizeDetail() {
    this.isLoading = true
    try {
      const response = await api().charge_grade_web.prize_list.get({
        thresholdSettingId: this.thresholdSettingId,
        checkVersion: this.checkVersion,
      })
      this.user = response.userInfo
      this.coin = response.totalCoin
      this.thresholdSetting = response.chargeGradeThresholdSetting
      this.lowAmountRange = Formatter.numberWithCommas(
        this.thresholdSetting.lowAmountRange
      )
      this.prizeSettings = response.chargeGradePrizeSettings

      if (!this.thresholdSetting.id || !this.prizeSettings.length) {
        this.isNotFound = true
      }
    } catch (error) {
      if (checkInMaintenance(error)) {
        return
      }

      if (!handleUnauthorized(error)) {
        // 401エラー以外はエラーとして扱う
        this.isNotFound = true
      }
    } finally {
      this.isLoading = false
    }
  }

  showNotFound() {
    return this.isNotFound && !this.isLoading
  }

  isWebView() {
    return getTokenFromCookie() !== undefined
  }

  get headerBackGroundImageStyles() {
    return {
      'background-image': `url('${this.thresholdSetting.backgroundImageUrl}')`,
    }
  }

  get title() {
    // nullをわたすとタイトルロゴが表示され、stringを渡すとその文字列が表示される
    return this.showNotFound() || this.isWebView() ? '' : null
  }
}
</script>

<style scoped>
.charge_grade_prize_detail_notfound {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
}

.account_info {
  display: flex;
  position: sticky;
  align-items: flex-end;
  justify-content: flex-end;
  top: 0px;
  right: 0px;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 16px;
  padding-right: 16px;
  min-height: 44px;
  max-width: 40%;
  margin-left: auto;
  flex: none;
  order: 0;
  flex-grow: 0;
  z-index: 3;
}

.account_info .icon {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
}

.account_info .info {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
}

.account_info .username {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  margin-right: 8px;
  font-family: 'Hiragino Sans', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 10px;
  line-height: 16px;
  width: 45%;
  min-width: 115px;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-all;
  white-space: normal;
  color: #0f0f0f;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.account_info .coin_info /deep/ .coin_amount {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 8px;
  margin-left: 2px;
  font-family: 'Hiragino Sans', sans-serif;
  font-style: normal;
  font-weight: 300;
  font-size: 10px;
  line-height: 16px;
  color: #737373;
  flex: none;
  order: 1;
  flex-grow: 0;
}

.account_info .coin_info /deep/ .coin_wrapper {
  height: 16px;
  justify-content: flex-end;
}

.account_info .coin_info /deep/ .coin_symbol {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: xx-small;
  width: 14px;
  height: 14px;
}

.charge_grade_prize_detail_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;

  max-width: 100%;

  background: #ffffff;
  border-radius: 8px 8px 0px 0px;
  padding: 0 0 var(--safe-area-inset-bottom, 0px) 0;
}

.charge_grade_prize_detail_container .threshould_setting_header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;

  width: 100%;
  min-width: 375px;
  height: 182px;

  background-repeat: no-repeat;
  background-size: 100%;

  flex: none;
  order: 0;
  flex-grow: 0;
  z-index: 0;
}

.charge_grade_prize_detail_container
  .threshould_setting_header
  .threshould_setting_icon {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;

  width: 64px;
  height: 64px;

  flex: none;
  order: 0;
  flex-grow: 0;
  z-index: 2;
}

.charge_grade_prize_detail_container
  .threshould_setting_header
  .threshould_setting_text {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 30px;

  font-family: 'Hiragino Sans', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  letter-spacing: 0.15px;

  color: #ffffff;

  flex: none;
  order: 0;
  flex-grow: 0;
}

.charge_grade_prize_detail_container
  .threshould_setting_header
  .threshould_setting_detail_text {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 16px;

  font-family: 'Hiragino Sans', sans-serif;
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  letter-spacing: 0.4px;

  color: rgba(255, 255, 255, 0.8);

  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
}

.charge_grade_prize_detail_container .prize_contents_text {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 20px;

  margin-top: 32px;

  font-family: 'Hiragino Sans', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.5px;

  color: #0f0f0f;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

.charge_grade_prize_detail_container .prize_list_container {
  display: grid;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 0px;
  width: 100%;
  max-width: 343px;
  margin: 16px auto;

  @media (min-width: 800px) {
    grid-template-columns: repeat(3, 1fr);
  }
}

.charge_grade_prize_detail_container .prize_list_container .prize_item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 8px 12px 16px;
  gap: 8px;
  isolation: isolate;

  width: 165.5px;

  background: #f2f2f2;
  border-radius: 8px;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 1;

  @media (min-width: 800px) {
    width: 200px;
  }
}

.charge_grade_prize_detail_container
  .prize_list_container
  .prize_item
  .item_icon {
  width: 65px;
  height: 65px;

  flex: none;
  order: 0;
  flex-grow: 0;
  z-index: 0;
}

.charge_grade_prize_detail_container
  .prize_list_container
  .prize_item
  .item_name {
  font-family: 'Hiragino Sans', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.5px;

  color: #000000;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

.charge_grade_prize_detail_container
  .prize_list_container
  .prize_item
  .item_description {
  font-family: 'Hiragino Sans', sans-serif;
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 16px;
  text-align: left;
  letter-spacing: 0.4px;
  white-space: pre-wrap;

  color: #7b7b7b;

  flex: none;
  order: 2;
  align-self: stretch;
  flex-grow: 0;
}
</style>
